export default {
  default: 'Done!',
  createEntity: 'Entity successfully created',
  editEntity: 'Entity successfully edited',
  pathCopied: 'Path copied to clipboard',
  linkCopied: 'Link copied to clipboard',
  valueCopied: 'Value copied to clipboard',
  authKeyCopied: 'Auth key copied to clipboard',
  widgetIdCopied: 'Widget id copied to clipboard',
};
